import { render, staticRenderFns } from "./StudentPage.vue?vue&type=template&id=c788fe56&scoped=true&"
import script from "./StudentPage.vue?vue&type=script&lang=js&"
export * from "./StudentPage.vue?vue&type=script&lang=js&"
import style0 from "./StudentPage.vue?vue&type=style&index=0&id=c788fe56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c788fe56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
